import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, InputNumber, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { retrieveContributors } from "../../redux/actions/contributorActions";
import { getSpecificIncomeShare } from "../../redux/actions/incomeShareActions";
import { retrieveLabels } from "../../redux/actions/labelActions";
import { retrieveAllTracks } from "../../redux/actions/trackActions";
import { RootState } from "../../redux/rootReducer";
import { Actions, ContributorType } from "../../shared/constant";
import { SpecificTrackIncomeColumn } from "../../shared/table/columns";
import tableUtils from "../../utils/tableUtils";
import validateMessages, { Max100Validate } from "../../utils/validate";
import Icon from "../Icon/Icon";

const TrackIncomeFileds = ({
  form,
  onCancel,
  addTrackIncome,
  updateTrackIncome,
  editData,
  stateMode,
}: {
  form: any;
  onCancel: React.MouseEventHandler<HTMLElement>;
  addTrackIncome: React.MouseEventHandler<HTMLElement>;
  updateTrackIncome: React.MouseEventHandler<HTMLElement>;
  editData: any;
  stateMode: string;
}) => {
  const dispatch = useDispatch();
  const [label, setLabel] = useState("");
  const [artist, setArtist] = useState("");
  const [effect, setEffect] = useState(false);
  const { allTracks } = useSelector((state: RootState) => state.track);
  const { allLabels } = useSelector((state: RootState) => state.label);
  const { allArtists } = useSelector((state: RootState) => state.contributor);

  // const getLabelName = (labelId: string) => {
  //   const l = allLabels.find((item: any) => item.id === labelId);
  //   return l?.name && l.name;
  // };

  useEffect(() => {
    if (stateMode === Actions.EDIT) {
      setLabel(editData.trackValues.label);
      setArtist(editData.trackValues.artist);
      setEffect(!effect);
    }

    dispatch(retrieveLabels({ page: "all" }));
    dispatch(
      retrieveContributors({
        type: ContributorType.ARTIST,
        page: "all",
      }),
    );
  }, []);

  useEffect(() => {
    dispatch(
      retrieveAllTracks({
        label,
        artist,
      }),
    );
  }, [effect]);

  const onLabelChange = (value: string) => {
    if (value) setLabel(value);
    else setLabel("");
    form.setFieldsValue({
      tracks: undefined,
    });
    setEffect(!effect);
  };

  const onArtistChange = (value: string) => {
    if (value) setArtist(value);
    else setArtist("");
    form.setFieldsValue({
      tracks: undefined,
    });
    setEffect(!effect);
  };

  return (
    <div className="default-border px-4 py-2 mb-6">
      <div className="text-16-bold pb-4">Add Track Income</div>

      <div className="grid grid-cols-2 gap-x-6">
        <Form.Item
          name="label"
          label="Producer"
          rules={[{ required: true }]}
          initialValue={
            stateMode === Actions.EDIT ? editData.trackValues.label : undefined
          }
        >
          <Select
            placeholder="Please select"
            allowClear
            showSearch
            onChange={onLabelChange}
          >
            {allLabels.map((el: any) => (
              <Select.Option key={el.name} value={el.name}>
                {el.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="artist"
          label="Artist"
          rules={[{ required: true }]}
          initialValue={
            stateMode === Actions.EDIT ? editData.trackValues.artist : undefined
          }
        >
          <Select
            placeholder="Please select"
            allowClear
            showSearch
            onChange={onArtistChange}
          >
            {allArtists.map((el: any) => (
              <Select.Option key={el.id} value={el.name}>
                {el.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="tracks"
          label="Track Title"
          rules={[{ required: true }]}
          initialValue={
            stateMode === Actions.EDIT ? editData.trackValues.tracks : undefined
          }
        >
          <Select
            mode="multiple"
            placeholder="Please select"
            allowClear
            filterOption={(inputValue, option) =>
              option?.props.children
                .toString()
                .toLowerCase()
                .includes(inputValue.toLowerCase())
            }
          >
            {allTracks.map((track: any) => (
              <Select.Option key={track.id} value={track.id}>
                {track.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="income_share"
          label="Artist Income Share (%)"
          rules={[
            { required: true },
            { validator: (_: any, value: number) => Max100Validate(value) },
          ]}
          initialValue={
            stateMode === Actions.EDIT
              ? editData.trackValues.income_share
              : undefined
          }
        >
          <InputNumber className="w-full" placeholder="Income Share %" />
        </Form.Item>
      </div>
      <div className="flex justify-end gap-x-2 pb-[14px] pt-3">
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="primary"
          onClick={
            stateMode === Actions.EDIT ? updateTrackIncome : addTrackIncome
          }
        >
          {stateMode === Actions.EDIT
            ? "Update Track Income"
            : "Add Track Income"}
        </Button>
      </div>
    </div>
  );
};

const TrackIncomeForm = ({
  mode,
  handleTrackFields,
}: {
  mode: string;
  handleTrackFields: Function;
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [data, setData] = useState<any>([]);
  const [editData, setEditData] = useState<any>([]);
  const [editIndex, setEditIndex] = useState<any>(null);
  const [stateMode, setStateMode] = useState("");
  const [illustrationVisible, setIllustrationVisible] = useState(true);
  const [formVisible, setFormVisible] = useState(false);
  const [tableVisible, setTableVisible] = useState(false);
  const { specificIncomeShare } = useSelector(
    (state: RootState) => state.incomeShare,
  );
  const { allTracks } = useSelector((state: RootState) => state.track);

  /* TODO income share for specific track is not client specific;
  so all the data coming in every client edit */

  // useEffect(() => {
  //   if (mode === Actions.EDIT) {
  //     dispatch(getSpecificIncomeShare({}));
  //   }
  // }, [mode]);

  useEffect(() => {
    dispatch(getSpecificIncomeShare({}));
  }, []);

  useEffect(() => {
    if (specificIncomeShare.length) {
      setIllustrationVisible(false);
      setTableVisible(true);
      setData(
        specificIncomeShare.map((item: any) => {
          return {
            tracks: item.title,
            id: item.id,
            share: item.exclusive_artist_share,
            // notes: keeping flag for the data that is coming from api
            flag: "API",
          };
        }),
      );
    }
  }, [specificIncomeShare]);

  useEffect(() => {
    handleTrackFields(data);
  }, [data]);

  const addInitialTrack = () => {
    setIllustrationVisible(false);
    setFormVisible(true);
  };

  const onCancel = () => {
    if (data.length) {
      setFormVisible(false);
      if (stateMode === Actions.EDIT) {
        setTableVisible(true);
        setStateMode("");
        setEditIndex(null);
      }
      return;
    }
    setIllustrationVisible(true);
    setFormVisible(false);
    setTableVisible(false);
  };

  const getTracksTitle = (t: string[]) => {
    const cTitle = t.map((id) => {
      const track = allTracks.find((item: any) => id === item.id);
      return track.title;
    });
    return cTitle?.join(", ");
  };

  const addTrackIncome = async () => {
    try {
      await form.validateFields();
    } catch (errorInfo) {
      return;
    }

    const fields = form.getFieldsValue();
    setData([
      ...data,
      {
        tracks: getTracksTitle(fields.tracks),
        id: fields.tracks?.join(", "),
        share: fields.income_share,
        trackValues: fields,
        flag: "",
      },
    ]);
    setTableVisible(true);
    setFormVisible(false);
  };

  const updateTrackIncome = async () => {
    try {
      await form.validateFields();
    } catch (errorInfo) {
      return;
    }

    const fields = form.getFieldsValue();
    const cData = [...data];
    cData.splice(editIndex, 1);

    cData.splice(editIndex, 0, {
      tracks: getTracksTitle(fields.tracks),
      id: fields.tracks?.join(", "),
      share: fields.income_share,
      trackValues: fields,
      flag: "",
    });
    setData(cData);
    setFormVisible(false);
    setTableVisible(true);
    setStateMode("");
    setEditIndex(null);
  };

  const addTrack = () => {
    setFormVisible(true);
  };

  const handleEdit = (index: number) => {
    setEditIndex(index);
    setStateMode(Actions.EDIT);
    setEditData(data[index]);
    setTableVisible(false);
    setFormVisible(true);
  };

  const getDeleteIndex = (record: any) =>
    data.findIndex((item: any) => item.id === record.id);

  const handleDelete = (record: any, index: number) => {
    // console.log(index, record);
    const cData = [...data];
    // TODO complicated: if user try to add the track and delete or edit
    if (mode === Actions.EDIT) {
      if (record.flag === "API") cData[getDeleteIndex(record)].share = null;
      else cData.splice(getDeleteIndex(record), 1);
    } else cData.splice(index, 1);

    setData(cData);
    if (!cData.length) {
      setFormVisible(false);
      setTableVisible(false);
      setIllustrationVisible(true);
    }
  };

  const actions = {
    title: "Actions",
    key: "action",
    render: (_: any, record: any, index: number) =>
      data.length && (
        <div className="flex gap-x-4">
          {!specificIncomeShare?.length && (
            <div onClick={() => handleEdit(index)} aria-hidden="true">
              <Icon
                icon="edit"
                className="h-5 w-5 text-primary cursor-pointer"
              />
            </div>
          )}
          <div onClick={() => handleDelete(record, index)} aria-hidden="true">
            <Icon
              icon="close"
              className="h-5 w-5 text-primary cursor-pointer"
            />
          </div>
        </div>
      ),
  };

  const getData = () => {
    if (mode === Actions.EDIT) {
      const cData = data.filter((item: any) => {
        if (item.share) return true;
        return false;
      });
      return cData;
    }
    return data;
  };

  return (
    <div className="min-h-[273px]">
      {illustrationVisible && (
        <div className="h-[382px]">
          <div className="flex flex-col items-center justify-center h-full space-y-2.5">
            <div className="border-4 border-solid border-disabled rounded-full h-20 w-20 flex items-center justify-center">
              <Icon
                icon="music"
                className="h-12 w-12 text-balck text-disabled"
              />
            </div>
            <div className="text-16-bold">
              Add Income Share Percentage for Specific Track
            </div>
            <div className="w-[560px] text-base text-secondary text-center">
              For special cases if income share needs to be redefined for
              specific Tracks of this client, that can be defined by adding
              track and profit details.
            </div>
            <Button
              type="primary"
              ghost
              icon={<PlusOutlined />}
              onClick={addInitialTrack}
            >
              Add Track
            </Button>
          </div>
        </div>
      )}
      {tableVisible && (
        <div className="mb-6">
          <Table
            columns={tableUtils.buildColumns(
              getData(),
              SpecificTrackIncomeColumn,
              actions,
            )}
            dataSource={getData()}
            pagination={false}
            size="middle"
          />
          <div className="mt-4 text-right">
            <Button
              type="primary"
              ghost
              icon={<PlusOutlined />}
              onClick={addTrack}
            >
              Add Track
            </Button>
          </div>
        </div>
      )}
      {formVisible && (
        <Form
          form={form}
          layout="vertical"
          name="trackIncomeForm"
          validateMessages={validateMessages}
          preserve={false}
        >
          <TrackIncomeFileds
            form={form}
            onCancel={onCancel}
            addTrackIncome={addTrackIncome}
            updateTrackIncome={updateTrackIncome}
            editData={editData}
            stateMode={stateMode}
          />
        </Form>
      )}
    </div>
  );
};

export default TrackIncomeForm;
